
import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/Navbar';

const contactInfo = [
  {
    icon: "ri-phone-line",
    title: "Phone",
    details: ["+61 431 323 137", "Available 9AM - 6PM"],
    link: "tel:+61431323137"
  },
  {
    icon: "ri-mail-line",
    title: "Email",
    details: ["media@matthewminchio.com", "Response within 24 hours"],
    link: "mailto:media@matthewminchio.com"
  },
  {
    icon: "ri-map-pin-line",
    title: "Service Areas",
    details: ["Townsville", "Brisbane", "Gold Coast"]
  },
  {
    icon: "ri-time-line",
    title: "Business Hours",
    details: ["Mon - Fri: 9AM - 6PM", "Sat: 10AM - 4PM", "Sun appointment"]
  }
];

const services = [
  "Real Estate Videography",
  "Commercial Video Production",
  "Social Media Content",
  "Brand Story Videos",
  "Product Showcase",
  "Event Coverage",
  "Drone Videography",
  "Other"
];

export default function Contact() {
  const [showThankYou, setShowThankYou] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);

    const firstName = (formData.get('first_name') || '').toString().trim();
    const lastName = (formData.get('last_name') || '').toString().trim();
    const fullName = [firstName, lastName].filter(Boolean).join(' ');

    const data = {
      name: fullName,
      email: (formData.get('email') || '').toString().trim(),
      phone: (formData.get('phone') || '').toString().trim(),
      service: (formData.get('service_interest') || '').toString().trim(),
      project_type: (formData.get('service_interest') || '').toString().trim(),
      message: (formData.get('project_details') || '').toString().trim()
    };

    if (!data.name || !data.email || !data.message) {
      alert('Please fill out your name, email, and project details.');
      return;
    }

    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
      const response = await fetch(`${backendUrl}/api/contact`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(data)
      });

      if (response.ok) {
        setShowThankYou(true);
        setTimeout(() => setShowThankYou(false), 5000);
        (e.target).reset();
      } else {
        alert('There was an error sending your message. Please try again.');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('There was an error sending your message. Please try again.');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-cyan-50">
      {/* Navigation */}
      <Navbar variant="light" position="absolute" />

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        {/* Video Background - Desktop */}
        <div className="absolute inset-0 w-full h-full hidden md:block">
          <iframe
            src="https://www.youtube.com/embed/YIPkAbm9RVQ?autoplay=1&mute=1&loop=1&playlist=YIPkAbm9RVQ&controls=0&showinfo=0&rel=0&iv_load_policy=3&modestbranding=1&playsinline=1&vq=hd1440"
            title="Contact Video Background"
            className="w-full h-full object-cover"
            style={{ minWidth: '100%', minHeight: '100%', transform: 'scale(1.1)' }}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
          {/* Video Overlay */}
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/70"></div>
        </div>

        {/* Video Background - Mobile (Shorts) */}
        <div className="absolute inset-0 w-full h-full md:hidden">
          <iframe
            src="https://www.youtube.com/embed/6fjQ9yKreGA?autoplay=1&mute=1&loop=1&playlist=6fjQ9yKreGA&controls=0&showinfo=0&rel=0&iv_load_policy=3&modestbranding=1&playsinline=1"
            title="Contact Mobile Video Background"
            className="w-full h-full object-cover"
            style={{ minWidth: '100%', minHeight: '100%', transform: 'scale(1.1)' }}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
          {/* Video Overlay */}
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/70"></div>
        </div>

        <div className="relative z-10 text-center px-6 max-w-6xl mx-auto text-white">
          <div className="mb-8">
            <span className="inline-block px-8 py-3 bg-white/20 backdrop-blur-sm rounded-full text-white font-semibold text-sm tracking-wider border border-white/30">
              GET IN TOUCH
            </span>
          </div>
          <h1 className="text-6xl md:text-8xl font-black mb-8 tracking-tight leading-none text-white drop-shadow-2xl">
            LET'S CREATE
            <span className="block bg-gradient-to-r from-blue-400 via-indigo-400 to-cyan-400 bg-clip-text text-transparent">
              TOGETHER
            </span>
          </h1>
          <p className="text-xl md:text-2xl text-white/90 max-w-4xl mx-auto leading-relaxed mb-12 font-light drop-shadow-lg">
            Ready to bring your vision to life? Contact us today for a free consultation and let's discuss your next video project
          </p>
          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <button 
              onClick={() => document.getElementById('contact-form')?.scrollIntoView({ behavior: 'smooth' })}
              className="px-10 py-4 bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-bold text-lg rounded-full hover:from-blue-700 hover:to-indigo-700 transition-all duration-300 transform hover:scale-105 shadow-2xl cursor-pointer whitespace-nowrap backdrop-blur-sm"
            >
              START PROJECT
            </button>
            <a 
              href="tel:+61431323137"
              className="px-10 py-4 bg-white/20 backdrop-blur-sm border-2 border-white/50 text-white font-bold text-lg rounded-full hover:bg-white/30 hover:border-white/70 transition-all duration-300 cursor-pointer whitespace-nowrap shadow-2xl"
            >
              CALL NOW
            </a>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
          <div className="animate-bounce">
            <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center">
              <div className="w-1 h-3 bg-white/70 rounded-full mt-2 animate-pulse"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section id="contact-form" className="py-32 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-16">
              <span className="inline-block px-8 py-3 bg-blue-100 rounded-full text-blue-700 font-semibold text-sm tracking-wider border border-blue-200 mb-6">
                GET IN TOUCH
              </span>
              <h2 className="text-5xl md:text-6xl font-black text-gray-900 mb-8 tracking-tight">
                Let's Discuss Your Project
              </h2>
              <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-8">
                Choose how you'd like to connect with us - schedule a consultation or send us a message
              </p>
            </div>

            <div className="grid lg:grid-cols-2 gap-12">
              {/* Calendly Booking Section */}
              <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
                <div className="p-8">
                  <div className="text-center mb-8">
                    <div className="w-16 h-16 bg-gradient-to-r from-blue-100 to-indigo-100 rounded-full flex items-center justify-center mx-auto mb-4">
                      <i className="ri-calendar-check-line text-3xl text-blue-600"></i>
                    </div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-3">Schedule a Consultation</h3>
                    <p className="text-gray-600">
                      Book a free 30-minute consultation to discuss your project in detail
                    </p>
                  </div>

                  {/* Calendly Widget */}
                  <div className="calendly-inline-widget" 
                       data-url="https://calendly.com/your-calendly-username/consultation"
                       style={{ minWidth: '320px', height: '600px' }}>
                  </div>
                  
                  <div className="mt-6 p-4 bg-blue-50 rounded-xl border border-blue-200">
                    <h4 className="font-semibold text-gray-900 mb-2">
                      <i className="ri-lightbulb-line text-blue-600 mr-2"></i>
                      What we'll cover:
                    </h4>
                    <ul className="text-sm text-gray-600 space-y-1">
                      <li>• Your project vision and goals</li>
                      <li>• Timeline and budget discussion</li>
                      <li>• Service recommendations</li>
                      <li>• Custom quote preparation</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Contact Form Section */}
              <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
                <div className="p-8">
                  <div className="text-center mb-8">
                    <div className="w-16 h-16 bg-gradient-to-r from-blue-100 to-indigo-100 rounded-full flex items-center justify-center mx-auto mb-4">
                      <i className="ri-mail-send-line text-3xl text-blue-600"></i>
                    </div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-3">Send Us a Message</h3>
                    <p className="text-gray-600">
                      Prefer to send details first? We'll get back to you within 24 hours
                    </p>
                  </div>

                  {/* Thank You Message */}
                  {showThankYou && (
                    <div className="mb-6 p-4 bg-green-50 border border-green-200 rounded-xl">
                      <div className="flex items-center justify-center text-green-700">
                        <i className="ri-check-double-line text-xl mr-2"></i>
                        <p className="font-semibold">Thank you! We'll be in touch within 24 hours.</p>
                      </div>
                    </div>
                  )}

                  <form onSubmit={handleSubmit} data-readdy-form id="contact-inquiry" className="space-y-6">
                    <div className="grid md:grid-cols-2 gap-6">
                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                          First Name *
                        </label>
                        <input
                          type="text"
                          name="first_name"
                          required
                          className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                          placeholder="Enter your first name"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                          Last Name *
                        </label>
                        <input
                          type="text"
                          name="last_name"
                          required
                          className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                          placeholder="Enter your last name"
                        />
                      </div>
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Email Address *
                      </label>
                      <input
                        type="email"
                        name="email"
                        required
                        className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                        placeholder="your.email@example.com"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Phone Number
                      </label>
                      <input
                        type="tel"
                        name="phone"
                        className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                        placeholder="+61 xxx xxx xxx"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Service Interest *
                      </label>
                      <select
                        name="service_interest"
                        required
                        className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all pr-8"
                      >
                        <option value="">Select a service</option>
                        {services.map((service, index) => (
                          <option key={index} value={service}>{service}</option>
                        ))}
                      </select>
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Project Details *
                      </label>
                      <textarea
                        name="project_details"
                        rows={4}
                        maxLength={500}
                        required
                        className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all resize-none"
                        placeholder="Tell us about your project vision, goals, and requirements..."
                      ></textarea>
                      <p className="text-sm text-gray-500 mt-2">Maximum 500 characters</p>
                    </div>

                    <div className="pt-4">
                      <button
                        type="submit"
                        className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 text-white py-4 px-6 rounded-xl font-bold text-lg hover:from-blue-700 hover:to-indigo-700 transition-all duration-300 cursor-pointer whitespace-nowrap shadow-lg transform hover:scale-105"
                      >
                        Send Message
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            {/* Additional Info */}
            <div className="mt-16 text-center">
              <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-200 max-w-4xl mx-auto">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  <i className="ri-time-line text-blue-600 mr-2"></i>
                  Response Times
                </h3>
                <div className="grid md:grid-cols-2 gap-8">
                  <div className="text-center">
                    <div className="text-3xl font-bold text-blue-600 mb-2">30 min</div>
                    <p className="text-gray-600">Consultation calls</p>
                  </div>
                  <div className="text-center">
                    <div className="text-3xl font-bold text-blue-600 mb-2">&lt; 24 hrs</div>
                    <p className="text-gray-600">Email responses</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Information Cards */}
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto mt-20">
              {contactInfo.map((info, index) => (
                <div key={index} className="text-center group">
                  <div className="w-20 h-20 bg-gradient-to-r from-blue-100 to-indigo-100 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                    <i className={`${info.icon} text-3xl text-blue-600`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-4">{info.title}</h3>
                  <div className="space-y-2">
                    {info.details.map((detail, detailIndex) => (
                      <p key={detailIndex} className={`${detailIndex === 0 && info.link ? 'font-semibold text-blue-600' : 'text-gray-600'}`}>
                        {info.link && detailIndex === 0 ? (
                          <a href={info.link} className="hover:text-blue-800 transition-colors cursor-pointer">
                            {detail}
                          </a>
                        ) : (
                          detail
                        )}
                      </p>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-32 bg-gradient-to-r from-blue-600 to-indigo-600 text-white">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-4xl md:text-5xl font-black mb-8 tracking-tight">Ready to Start Your Project?</h2>
          <p className="text-xl text-blue-100 mb-12 max-w-3xl mx-auto leading-relaxed">
            Don't wait - let&apos;s bring your vision to life with professional videography that makes an impact
          </p>
          <div className="flex flex-col sm-flex-row gap-6 justify-center">
            <a 
              href="tel:+61431323137"
              className="inline-block bg-white text-blue-600 px-10 py-4 font-bold text-lg rounded-full hover:bg-gray-100 transition-all duration-300 cursor-pointer whitespace-nowrap shadow-lg transform hover:scale-105"
            >
              CALL NOW: +61 431 323 137
            </a>
            <a 
              href="mailto:media@matthewminchio.com"
              className="inline-block bg-white/20 backdrop-blur-sm border-2 border-white/50 text-white px-10 py-4 font-bold text-lg rounded-full hover:bg-white/30 hover:border-white/70 transition-all duration-300 cursor-pointer whitespace-nowrap shadow-lg"
            >
              EMAIL US
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-white py-12">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-4 gap-8 mb-8">
            {/* Company Info */}
            <div className="md:col-span-1">
              <div className="flex items-center space-x-3 mb-4">
                <img 
                  src="https://images.squarespace-cdn.com/content/v1/6329980709c417765c18ef9c/1663928993488-9PHELX1GHR1MGT4SNOLP/minchio+brothers+logo.png?format=100w" 
                  alt="Minchio Brothers Logo" 
                  className="h-10 w-10"
                />
                <span className="text-gray-900 font-bold text-lg">MINCHIO BROTHERS</span>
              </div>
              <p className="text-gray-600 mb-4 text-sm leading-relaxed">
                Professional videography services across Queensland, specializing in Real Estate, Commercial, and Social Media content.
              </p>
              <div className="flex space-x-3">
                <a href="https://www.instagram.com/minchiobrothers/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-900 rounded-full flex items-center justify-center hover:bg-gray-800 transition-colors cursor-pointer">
                  <i className="ri-instagram-fill text-white text-lg"></i>
                </a>
                <a href="mailto:media@matthewminchio.com" className="w-10 h-10 bg-gray-900 rounded-full flex items-center justify-center hover:bg-gray-800 transition-colors cursor-pointer">
                  <i className="ri-mail-fill text-white text-lg"></i>
                </a>
                <a href="tel:+61431323137" className="w-10 h-10 bg-gray-900 rounded-full flex items-center justify-center hover:bg-gray-800 transition-colors cursor-pointer">
                  <i className="ri-phone-fill text-white text-lg"></i>
                </a>
              </div>
            </div>

            {/* Services */}
            <div>
              <h3 className="text-gray-900 font-bold mb-4">Services</h3>
              <ul className="space-y-2 text-sm">
                <li><Link to="/real-estate" className="text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">Real Estate Videography</Link></li>
                <li><Link to="/commercial" className="text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">Commercial Production</Link></li>
                <li><Link to="/social-media" className="text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">Social Media Content</Link></li>
                <li><span className="text-gray-600">Drone Videography</span></li>
                <li><span className="text-gray-600">Event Coverage</span></li>
                <li><span className="text-gray-600">Brand Storytelling</span></li>
              </ul>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="text-gray-900 font-bold mb-4">Quick Links</h3>
              <ul className="space-y-2 text-sm">
                <li><Link to="/" className="text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">Home</Link></li>
                <li><Link to="/reviews" className="text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">Client Reviews</Link></li>
                <li><Link to="/contact" className="text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">Contact Us</Link></li>
                <li><Link to="/contact" className="text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">Get Quote</Link></li>
                <li><a href="https://www.minchsolutions.au" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">Minch Solutions</a></li>
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h3 className="text-gray-900 font-bold mb-4">Contact Info</h3>
              <div className="space-y-3 text-sm">
                <div className="flex items-start space-x-2">
                  <i className="ri-phone-line text-gray-600 mt-0.5"></i>
                  <div>
                    <a href="tel:+61431323137" className="text-gray-600 hover:text-gray-900 transition-colors cursor-pointer font-medium">+61 431 323 137</a>
                    <p className="text-gray-500 text-xs">Available 9AM - 6PM</p>
                  </div>
                </div>
                <div className="flex items-start space-x-2">
                  <i className="ri-mail-line text-gray-600 mt-0.5"></i>
                  <div>
                    <a href="mailto:media@matthewminchio.com" className="text-gray-600 hover:text-gray-900 transition-colors cursor-pointer font-medium">media@matthewminchio.com</a>
                    <p className="text-gray-500 text-xs">24hr response time</p>
                  </div>
                </div>
                <div className="flex items-start space-x-2">
                  <i className="ri-map-pin-line text-gray-600 mt-0.5"></i>
                  <div>
                    <p className="text-gray-600 font-medium">Service Areas:</p>
                    <p className="text-gray-500 text-xs">Townsville, Brisbane, Gold Coast</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="border-t border-gray-200 pt-6 flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-500 text-sm mb-4 md:mb-0">© 2021 MINCHIO BROTHERS. ALL RIGHTS RESERVED</p>
            <div className="flex items-center space-x-4 text-sm">
              <a href="https://www.minchsolutions.au" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-gray-600 cursor-pointer">
                Made by Minchsolutions
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
